import template from './leave_categories_help.html';
import * as Utils from '../../lib/savanna_utils.js';

class LeaveCategoriesHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
}

class LeaveCategoriesHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new LeaveCategoriesHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'LeaveCategoriesHelp',
	dialog_class: LeaveCategoriesHelpPage,
	template: template,
	template_filename: 'translation/dialogs/leave_categories_help',
	provider: 'ps'
};
